import React, { useContext, useEffect, useState } from 'react'
import './Myaccount.css'
import Tangelo from "../../imgs/tangelo.png";
import Ribbon from "../../imgs/ribbon.png";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Globalcontext from '../../Context/Globalcontext';

const Myaccount = () => {
    const navigate = useNavigate();
    const notifyerror = (msg) => toast.error(msg);
    const notifysuccess = (msg) => toast.success(msg);
    const [input, setInput] = useState({ name: localStorage.getItem("glname"), grade: localStorage.getItem("glgrade"), school: localStorage.getItem("glschool"), coordinator: localStorage.getItem("glcoordinator"), dob: localStorage.getItem("gldob"), gender: localStorage.getItem("glgender"), studentstatus: localStorage.getItem("glstudentstatus"), language: localStorage.getItem("gllanguage"), mobno: localStorage.getItem("glmobno") });
    const a = useContext(Globalcontext);

    useEffect(() => {
        if (localStorage.getItem("gllogin") === '') {
            navigate('/studentiqtest');
        }
    })

    const handleChange = (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));
    }

    const handlesignout = () => {
        localStorage.setItem('glname', '');
        localStorage.setItem('glgrade', '');
        localStorage.setItem('glschool', '');
        localStorage.setItem('glcoordinator', '');
        localStorage.setItem('gldob', '');
        localStorage.setItem('glgender', '');
        localStorage.setItem('glstudentstatus', '');
        localStorage.setItem('gllanguage', '');
        localStorage.setItem('glmobno', '');
        localStorage.setItem('glgrade2', '');
        localStorage.setItem('glresult', '');
        localStorage.setItem('gletime', '');
        localStorage.setItem('glrand', '');
        localStorage.setItem('glmaintest', '');
        localStorage.setItem('gllogin', '');

        setempty();

        navigate('/');
        notifysuccess('Logged out..');

    }

    const setempty = () => {
        a.setq1array({ "option": '', "correct": '' });
        a.setq2array({ "option": '', "correct": '' });
        a.setq3array({ "option": '', "correct": '' });
        a.setq4array({ "option": '', "correct": '' });
        a.setq5array({ "option": '', "correct": '' });
        a.setq6array({ "option": '', "correct": '' });
        a.setq7array({ "option": '', "correct": '' });
        a.setq8array({ "option": '', "correct": '' });
        a.setq9array({ "option": '', "correct": '' });
        a.setq10array({ "option": '', "correct": '' });
        a.setq11array({ "option": '', "correct": '' });
        a.setq12array({ "option": '', "correct": '' });
        a.setq13array({ "option": '', "correct": '' });
        a.setq14array({ "option": '', "correct": '' });
        a.setq15array({ "option": '', "correct": '' });
        a.setq16array({ "option": '', "correct": '' });
        a.setq17array({ "option": '', "correct": '' });
        a.setq18array({ "option": '', "correct": '' });
        a.setq19array({ "option": '', "correct": '' });
        a.setq20array({ "option": '', "correct": '' });

        a.setq1('');
        a.setq2('');
        a.setq3('');
        a.setq4('');
        a.setq5('');
        a.setq6('');
        a.setq7('');
        a.setq8('');
        a.setq9('');
        a.setq10('');
        a.setq11('');
        a.setq12('');
        a.setq13('');
        a.setq14('');
        a.setq15('');
        a.setq16('');
        a.setq17('');
        a.setq18('');
        a.setq19('');
        a.setq20('');

        a.setSeconds(59);
        a.setMinutes(29);
        a.setIndex(0);
        a.setCorrect(0);
        a.setAnasweredtemp(0);
        a.setElminutes(0);
        a.setElseconds(0);
        a.setSolutionflag("false");

    }

    const handlesave = () => {
        let rawData = {
            sname: input.name,
            mobno: input.mobno,
            language: input.language,
            dob: input.dob,
            gender: input.gender,
            grade: input.grade,
            school: input.school,
            coordinator: input.coordinator,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData);

        axios.post('https://softtesting.in/iniqtest/cust/studentpanel/updateuser.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {

            if (response.data == "Updated!") {
                localStorage.setItem('glname', input.name);
                localStorage.setItem('glgrade', input.grade);
                localStorage.setItem('glschool', input.school);
                localStorage.setItem('glcoordinator', input.coordinator);
                localStorage.setItem('gldob', input.dob);
                localStorage.setItem('glgender', input.gender);
                localStorage.setItem('gllanguage', input.language);
                localStorage.setItem('glmobno', input.mobno);

                navigate('/Dashboard');
                notifysuccess("Account Updated!");
            }
            else {
                notifyerror("Something went wrong!");
            }
        }).catch(err => {
            console.log(err);
        });
    }

    return (
        <div className='myaccount'>
            <div className="whiteboxmyaccount">
                <div className="savechanges">
                    <button onClick={handlesave} >SAVE</button>
                </div>
                <div className="toprow">
                    <img className='img1' src={Tangelo} alt="" />
                    <img className='img2' src={Ribbon} alt="" />
                    <span style={{ fontWeight: "bold", marginTop: "4px", fontSize: "19px" }}>{input.name}</span>
                    <span style={{ fontWeight: "bold", marginTop: "1px", fontSize: "14px" }}>{input.grade}</span>
                    <div className='line' />
                </div>
                <div className="bottommyaccount">
                    <div className="bottomrowmyaccount">
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>Mobile Number</span>
                            <span style={{ marginTop: "5px" }}>{input.mobno}</span>
                            <div className='line' />
                            <span style={{ marginTop: "15px", fontSize: "12px", fontWeight: "bold" }}>Whatsapp Reminder   :   OFF</span>
                        </div>
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>Student Name</span>
                            <input style={{ marginTop: "5px" }} value={input.name} name="name" id='name' onChange={handleChange}></input>

                        </div>
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>School Name</span>
                            <span style={{ marginTop: "5px" }}>{input.school}</span>
                        </div>
                    </div>

                    <div className="bottomrowmyaccount">
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>Coordinator Name</span>
                            <span style={{ marginTop: "5px" }}>{input.coordinator}</span>

                        </div>
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>Grade</span>
                            <select style={{ marginTop: "5px" }} name="grade" id="grade" value={input.grade} onChange={handleChange} className="form-select" aria-label="Select Grade">
                                <option defaultValue="Select Grade">Select Grade</option>
                                <option value="CLASS - 1">CLASS - 1</option>
                                <option value="CLASS - 2">CLASS - 2</option>
                                <option value="CLASS - 3">CLASS - 3</option>
                                <option value="CLASS - 4">CLASS - 4</option>
                                <option value="CLASS - 5">CLASS - 5</option>
                                <option value="CLASS - 6">CLASS - 6</option>
                                <option value="CLASS - 7">CLASS - 7</option>
                                <option value="CLASS - 8">CLASS - 8</option>
                                <option value="CLASS - 9">CLASS - 9</option>
                                <option value="CLASS - 10">CLASS - 10</option>
                                <option value="CLASS - 11">CLASS - 11</option>
                                <option value="CLASS - 12">CLASS - 12</option>
                                <option value="Under Graduates">Under Graduates</option>
                                <option value="Post Graduates">Post Graduates</option>
                                <option value="Professionals">Professionals</option>
                            </select>

                        </div>
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>Gender</span>
                            <select style={{ marginTop: "5px" }} name="gender" id="gender" value={input.gender} onChange={handleChange} className="form-select" aria-label="Select Language">
                                <option defaultValue="Select Language">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>

                        </div>
                    </div>
                    <div className="bottomrowmyaccount">
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>Date of Birth</span>
                            <input style={{ marginTop: "5px" }} maxLength="10" type="date" id="dob" name="dob" value={input.dob} onChange={handleChange} />

                        </div>
                        <div className="boxmyaccount">
                            <span style={{ fontWeight: "bold" }}>Language</span>
                            <select style={{ marginTop: "5px" }} name="language" id="language" value={input.language} onChange={handleChange} className="form-select" aria-label="Select Language">
                                <option defaultValue="Select Language">Select Language</option>
                                <option value="English">English</option>
                                <option value="Hindi">Hindi</option>
                                <option value="Marathi">Marathi</option>
                            </select>

                        </div>
                        <button onClick={handlesignout} className='signout2'>Sign Out</button>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default Myaccount
